export default __webpack_public_path__ + "static/media/Ltst-3.e0f660ad.jpg";